import {
  asBoolean,
  asNumber,
  asString,
  asStringArray,
} from '../http/normalise';
import { ApiSession, ApiTopicTag, ApiTrack } from './session.dto';
import { Session, SessionType, TopicTag, Track } from './session.model';

const SESSION_TYPES: ReadonlySet<string> = new Set<string>([
  'talk',
  'workshop',
  'panel',
  'break',
]);

function asSessionType(value: unknown): SessionType {
  if (typeof value === 'string' && SESSION_TYPES.has(value)) {
    return value as SessionType;
  }
  return 'talk';
}

export function mapSession(dto: ApiSession): Session {
  const startsAt = asString(dto.startsAt) ?? '';

  return {
    id: asString(dto.id) ?? '',
    eventId: asString(dto.eventId) ?? '',
    title: asString(dto.title) ?? '',
    description: asString(dto.description),
    startsAt,
    endsAt: asString(dto.endsAt) ?? startsAt,
    trackId: asString(dto.trackId),
    roomId: asString(dto.roomId),
    topicTagIds: asStringArray(dto.topicTagIds),
    type: asSessionType(dto.type),
    capacity: asNumber(dto.capacity),
    speakerIds: asStringArray(dto.speakerIds),
    documentIds: asStringArray(dto.documentIds),
    published: asBoolean(dto.published, false),
    bookmarkCount: asNumber(dto.bookmarkCount) ?? 0,
  };
}

export function mapTrack(dto: ApiTrack): Track {
  return {
    id: asString(dto.id) ?? '',
    name: asString(dto.name) ?? '',
    colorHex: asString(dto.colorHex),
    sortOrder: asNumber(dto.sortOrder) ?? 0,
  };
}

export function mapTopicTag(dto: ApiTopicTag): TopicTag {
  return { id: asString(dto.id) ?? '', label: asString(dto.label) ?? '' };
}
